const defaultTheme = require('tailwindcss/defaultTheme')

module.exports = {
    content: [
        './vendor/laravel/framework/src/Illuminate/Pagination/resources/views/*.blade.php',
        './storage/framework/views/*.php',
        './resources/views/**/*.blade.php',
        './resources/views/*.blade.php',
        './resources/views/*.css',
        './resources/js/**/*.{js,css}',
        './resources/js/**/*.js',
    ],

    theme: {
        colors: {
            // Project colors
            primaryGreen: '#45908D',
            primaryGreenDark: '#146966',
            primaryGreenDarker: '#094F4C',
            secondaryGreen: '#BFE7E0',
            secondaryGreenDark: '#80D0C3',
            lightGreen: '#DDFAD9',
            demoGreen: '#CDD892',
            darkDemoGreen: '#AABF3B',
            transparent: 'transparent',
            black: '#1b1b1b',
            lightBlack: '#242424',
            overlayBlack: '#000000, 25%',
            white: '#FFFFFF',
            bone: '#FBFAF8',
            lightLightGrey: '#F4F4F4',
            lightGrey: '#F8F8F8',
            darkLightGrey: '#F0F0F0',
            lightMediumGrey: '#ECECEC',
            mediumGrey: '#D6D6D6',
            lightDarkGrey: '#7C7C7C',
            mediumDarkGrey: '#4E4E4E',
            darkGrey: '#3A3A3A',
            darkDarkGrey: '#1B1B1B',
            lightRed: '#FFD9D9',
            candyRed: '#C13A52',
            alertRed: '#FF0000',
            alertRedDark: '#9D1C1C',
            alertGreen: '#1FDD00',
            quizGrey: '#EEEEEE',

            errorRed: '#f33b3b',

            examGreen: '#5F9B56',
            examRed: '#CD2828',

            feedbackOne: '#E78383',
            feedbackTwo: '#EFC6A9',
            feedbackThree: '#EFE3A9',
            feedbackFour: '#B8D5B4',
            feedbackFive: '#65B958',

            // Subject colors
            subject: {
                // blue
                teknik: {
                    blockBackground: '#a7ceea',
                    light: '#82BAE2',
                    dark: '#285DA5',
                },
                tyska: {
                    blockBackground: '#a7ceea',
                    light: '#82BAE2',
                    dark: '#285DA5',
                },
                franska: {
                    blockBackground: '#a7ceea',
                    light: '#82BAE2',
                    dark: '#285DA5',
                },
                spanska: {
                    blockBackground: '#a7ceea',
                    light: '#82BAE2',
                    dark: '#285DA5',
                },


                // blue/purple
                kemi: {
                    blockBackground: '#adbfde',
                    light: '#8BA4D0',
                    dark: '#344093',
                },
                slojd: {
                    blockBackground: '#adbfde',
                    light: '#8BA4D0',
                    dark: '#344093',
                },


                // purple/blue
                samhallskunskap: {
                    blockBackground: '#bebedb',
                    light: '#A3A3CC',
                    dark: '#594495',
                },
                musik: {
                    blockBackground: '#bebedb',
                    light: '#A3A3CC',
                    dark: '#594495',
                },


                // purple
                engelska: {
                    blockBackground: '#c6afd0',
                    light: '#AE8EBC',
                    dark: '#8E4191',
                },
                "idrott-och-halsa": {
                    blockBackground: '#c6afd0',
                    light: '#AE8EBC',
                    dark: '#8E4191',
                },


                // pink
                religion: {
                    blockBackground: '#f1c6da',
                    light: '#EBAECB',
                    dark: '#CD3681',
                },
                bild: {
                    blockBackground: '#f1c6da',
                    light: '#EBAECB',
                    dark: '#CD3681',
                },


                // peach
                svenska: {
                    blockBackground: '#f3c7c6',
                    light: '#EEB0AE',
                    dark: '#C13A52',
                },
                modersmal: {
                    blockBackground: '#f3c7c6',
                    light: '#EEB0AE',
                    dark: '#C13A52',
                },
                "modersmal-nationella-minoritetssprak": {
                    blockBackground: '#f3c7c6',
                    light: '#EEB0AE',
                    dark: '#C13A52',
                },
                samiska: {
                    blockBackground: '#f3c7c6',
                    light: '#EEB0AE',
                    dark: '#C13A52',
                },
                teckenspråk: {
                    blockBackground: '#f3c7c6',
                    light: '#EEB0AE',
                    dark: '#C13A52',
                },


                // peach/orange
                fysik: {
                    blockBackground: '#f8d5af',
                    light: '#F5C48E',
                    dark: '#E36C3F',
                },
                "sva-for-nyanlanda": {
                    blockBackground: '#f8d5af',
                    light: '#F5C48E',
                    dark: '#E36C3F',
                },
                sva: {
                    blockBackground: '#f8d5af',
                    light: '#F5C48E',
                    dark: '#E36C3F',
                },


                // green
                geografi: {
                    blockBackground: '#d9e5ac',
                    light: '#CADA89',
                    dark: '#8EBE55',
                },
                "hem-och-konsumentkunskap": {
                    blockBackground: '#d9e5ac',
                    light: '#CADA89',
                    dark: '#8EBE55',
                },


                // marble green
                biologi: {
                    blockBackground: '#c2debd',
                    light: '#A9D0A2',
                    dark: '#52B083',
                },
                matematik: {
                    blockBackground: '#c2debd',
                    light: '#A9D0A2',
                    dark: '#52B083',
                },


                // yellow
                historia: {
                    blockBackground: '#fbeab5',
                    light: '#FAE296',
                    dark: '#EA9149',
                },


                // turqoise
                edutainment: {
                    blockBackground: '#b4ddde',
                    light: '#94CFD0',
                    dark: '#557E87',
                },
            },
        },
        container: {
            screens: {
                sm: '768px',
                md: '1024px',
                lg: '1280px',
                xl: '1440px',
            },
        },
        extend: {
            fontFamily: {
                primary: ['termina', ...defaultTheme.fontFamily.sans],
                secondary: ['Roboto', ...defaultTheme.fontFamily.sans],
            },
            fontSize: {
                xxxSmall: ['12px', '1.2'],
                xxSmall: ['14px', '1.2'],
                xSmall: ['16px', '1.2'],
                small: ['18px', '1.2'],
                base: ['20px', '1.2'],
                medium: ['22px', '1.2'],
                large: ['24px', '1.2'],
                xLarge: ['28px', '1.2'],
                xxLarge: ['34px', '1.2'],
                xxxLarge: ['42px', '1.2'],
            },
            height: {
                'full-minus-header': 'calc(100vh - 5rem)',
            },
        },
    },

    variants: {
        extend: {
            opacity: ['disabled'],
        },
    },

    plugins: [
        require('@tailwindcss/forms'),
        require('@tailwindcss/line-clamp'),
    ],
}
